import { render, staticRenderFns } from "./barItem.vue?vue&type=template&id=94c6d180&"
import script from "./barItem.vue?vue&type=script&lang=js&"
export * from "./barItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "barItem.vue"
export default component.exports